import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches all files attached to a patient (via notes and tasks), most recent first. */
export function useListPatientFiles(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-files', patientId],
    queryFn: async () => {
      const response = await api.get('/patients/:patientId/files', { params: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.files
    },
  })
}
